// src/specs/v1/types.ts
var GoalStatus = /* @__PURE__ */ ((GoalStatus2) => {
  GoalStatus2["DONE"] = "DONE";
  GoalStatus2["FAILED"] = "FAILED";
  GoalStatus2["IN_PROGRESS"] = "IN_PROGRESS";
  return GoalStatus2;
})(GoalStatus || {});
var ModelClass = /* @__PURE__ */ ((ModelClass2) => {
  ModelClass2["SMALL"] = "small";
  ModelClass2["MEDIUM"] = "medium";
  ModelClass2["LARGE"] = "large";
  ModelClass2["EMBEDDING"] = "embedding";
  ModelClass2["IMAGE"] = "image";
  return ModelClass2;
})(ModelClass || {});
var ModelProviderName = /* @__PURE__ */ ((ModelProviderName2) => {
  ModelProviderName2["OPENAI"] = "openai";
  ModelProviderName2["ETERNALAI"] = "eternalai";
  ModelProviderName2["ANTHROPIC"] = "anthropic";
  ModelProviderName2["GROK"] = "grok";
  ModelProviderName2["GROQ"] = "groq";
  ModelProviderName2["LLAMACLOUD"] = "llama_cloud";
  ModelProviderName2["TOGETHER"] = "together";
  ModelProviderName2["LLAMALOCAL"] = "llama_local";
  ModelProviderName2["LMSTUDIO"] = "lmstudio";
  ModelProviderName2["GOOGLE"] = "google";
  ModelProviderName2["MISTRAL"] = "mistral";
  ModelProviderName2["CLAUDE_VERTEX"] = "claude_vertex";
  ModelProviderName2["REDPILL"] = "redpill";
  ModelProviderName2["OPENROUTER"] = "openrouter";
  ModelProviderName2["OLLAMA"] = "ollama";
  ModelProviderName2["HEURIST"] = "heurist";
  ModelProviderName2["GALADRIEL"] = "galadriel";
  ModelProviderName2["FAL"] = "falai";
  ModelProviderName2["GAIANET"] = "gaianet";
  ModelProviderName2["ALI_BAILIAN"] = "ali_bailian";
  ModelProviderName2["VOLENGINE"] = "volengine";
  ModelProviderName2["NANOGPT"] = "nanogpt";
  ModelProviderName2["HYPERBOLIC"] = "hyperbolic";
  ModelProviderName2["VENICE"] = "venice";
  ModelProviderName2["NVIDIA"] = "nvidia";
  ModelProviderName2["NINETEEN_AI"] = "nineteen_ai";
  ModelProviderName2["AKASH_CHAT_API"] = "akash_chat_api";
  ModelProviderName2["LIVEPEER"] = "livepeer";
  ModelProviderName2["LETZAI"] = "letzai";
  ModelProviderName2["DEEPSEEK"] = "deepseek";
  ModelProviderName2["INFERA"] = "infera";
  ModelProviderName2["BEDROCK"] = "bedrock";
  ModelProviderName2["ATOMA"] = "atoma";
  ModelProviderName2["SECRETAI"] = "secret_ai";
  ModelProviderName2["NEARAI"] = "nearai";
  return ModelProviderName2;
})(ModelProviderName || {});
var CacheStore = /* @__PURE__ */ ((CacheStore2) => {
  CacheStore2["REDIS"] = "redis";
  CacheStore2["DATABASE"] = "database";
  CacheStore2["FILESYSTEM"] = "filesystem";
  return CacheStore2;
})(CacheStore || {});
var Service = class _Service {
  static {
    this.instance = null;
  }
  static get serviceType() {
    throw new Error("Service must implement static serviceType getter");
  }
  static getInstance() {
    if (!_Service.instance) {
      _Service.instance = new this();
    }
    return _Service.instance;
  }
  get serviceType() {
    return this.constructor.serviceType;
  }
};
var IrysMessageType = /* @__PURE__ */ ((IrysMessageType2) => {
  IrysMessageType2["REQUEST"] = "REQUEST";
  IrysMessageType2["DATA_STORAGE"] = "DATA_STORAGE";
  IrysMessageType2["REQUEST_RESPONSE"] = "REQUEST_RESPONSE";
  return IrysMessageType2;
})(IrysMessageType || {});
var IrysDataType = /* @__PURE__ */ ((IrysDataType2) => {
  IrysDataType2["FILE"] = "FILE";
  IrysDataType2["IMAGE"] = "IMAGE";
  IrysDataType2["OTHER"] = "OTHER";
  return IrysDataType2;
})(IrysDataType || {});
var ServiceType = /* @__PURE__ */ ((ServiceType2) => {
  ServiceType2["IMAGE_DESCRIPTION"] = "image_description";
  ServiceType2["TRANSCRIPTION"] = "transcription";
  ServiceType2["VIDEO"] = "video";
  ServiceType2["TEXT_GENERATION"] = "text_generation";
  ServiceType2["BROWSER"] = "browser";
  ServiceType2["SPEECH_GENERATION"] = "speech_generation";
  ServiceType2["PDF"] = "pdf";
  ServiceType2["INTIFACE"] = "intiface";
  ServiceType2["AWS_S3"] = "aws_s3";
  ServiceType2["BUTTPLUG"] = "buttplug";
  ServiceType2["SLACK"] = "slack";
  ServiceType2["VERIFIABLE_LOGGING"] = "verifiable_logging";
  ServiceType2["IRYS"] = "irys";
  ServiceType2["TEE_LOG"] = "tee_log";
  ServiceType2["GOPLUS_SECURITY"] = "goplus_security";
  ServiceType2["WEB_SEARCH"] = "web_search";
  ServiceType2["EMAIL_AUTOMATION"] = "email_automation";
  ServiceType2["NKN_CLIENT_SERVICE"] = "nkn_client_service";
  ServiceType2["DATABASE_MIGRATION"] = "database_migration";
  return ServiceType2;
})(ServiceType || {});
var LoggingLevel = /* @__PURE__ */ ((LoggingLevel2) => {
  LoggingLevel2["DEBUG"] = "debug";
  LoggingLevel2["VERBOSE"] = "verbose";
  LoggingLevel2["NONE"] = "none";
  return LoggingLevel2;
})(LoggingLevel || {});
var TokenizerType = /* @__PURE__ */ ((TokenizerType2) => {
  TokenizerType2["Auto"] = "auto";
  TokenizerType2["TikToken"] = "tiktoken";
  return TokenizerType2;
})(TokenizerType || {});
var TranscriptionProvider = /* @__PURE__ */ ((TranscriptionProvider2) => {
  TranscriptionProvider2["OpenAI"] = "openai";
  TranscriptionProvider2["Deepgram"] = "deepgram";
  TranscriptionProvider2["Local"] = "local";
  return TranscriptionProvider2;
})(TranscriptionProvider || {});
var ActionTimelineType = /* @__PURE__ */ ((ActionTimelineType2) => {
  ActionTimelineType2["ForYou"] = "foryou";
  ActionTimelineType2["Following"] = "following";
  return ActionTimelineType2;
})(ActionTimelineType || {});
var KnowledgeScope = /* @__PURE__ */ ((KnowledgeScope2) => {
  KnowledgeScope2["SHARED"] = "shared";
  KnowledgeScope2["PRIVATE"] = "private";
  return KnowledgeScope2;
})(KnowledgeScope || {});
var CacheKeyPrefix = /* @__PURE__ */ ((CacheKeyPrefix2) => {
  CacheKeyPrefix2["KNOWLEDGE"] = "knowledge";
  return CacheKeyPrefix2;
})(CacheKeyPrefix || {});

export {
  GoalStatus,
  ModelClass,
  ModelProviderName,
  CacheStore,
  Service,
  IrysMessageType,
  IrysDataType,
  ServiceType,
  LoggingLevel,
  TokenizerType,
  TranscriptionProvider,
  ActionTimelineType,
  KnowledgeScope,
  CacheKeyPrefix
};
